import { FeaturesConfig } from "~/backend/generated/Features/model/featuresConfig";
import { ContextManager } from "~/modules/contextManager/ContextManager";
import { featuresProviderImpl } from "../FeaturesProvider/featuresProviderImpl/featuresProviderImpl";

export const getFeaturesConfig = async (token: string, uiVersion?: string): Promise<FeaturesConfig> => {
    return featuresProviderImpl(ContextManager.newInstance())(token, uiVersion);
};
